<template>
    <form @submit.prevent="submit">
        <template v-if="tokenIsValid">
            <div class="token-info" v-if="!hashFromUrl">
                <p class="token-information col s12 auth-layout-text-and-icon">
                    {{ 'Bitte prüfen Sie Ihr E-Mail Postfach um Ihr Passwort zu ändern' | translate }}
                </p>
            </div>
            <input class="auth-password auth-token auth-layout-login-form-text auth-layout-secondary"
                   v-model="hash" id="hash"
                   type="text" name="hash"
                   :data-vv-as="'Passwort Reset Token' | translate"
                   v-validate="'required'"
                   @focusout="validateField('hash')"
                   :disabled="!!hashFromUrl"
                   :class="generateValidationClassMapping('hash')"
                   autocomplete="off"
                   :placeholder="'Passwort Reset Token' | translate"
            >
            <label :data-error="errors.first('hash')"
                   class="auth-password">
            </label>

            <div v-if="withOldPasswordConfirmation">
                <input class="auth-password auth-layout-login-form-text auth-layout-secondary"
                       v-model="oldPassword" id="oldPassword" type="password"
                       name="oldPassword" :data-vv-as="'Altes Passwort' | translate"
                       v-validate="validation"
                       @focusout="validateField('password')"
                       :class="generateValidationClassMapping('oldPassword')"
                       autocomplete="off"
                       :placeholder="'Altes Passwort' | translate"
                >
                <label :data-error="errors.first('oldPassword')"
                       class="auth-password">
                </label>
            </div>

            <input class="auth-password auth-layout-login-form-text auth-layout-secondary"
                   v-model="newPassword" id="newPassword"
                   type="password" name="newPassword"
                   :data-vv-as="'Neues Passwort' | translate"
                   v-validate="newPasswordValidation"
                   @focusout="validateField('newPassword')"
                   :class="generateValidationClassMapping('newPassword')"
                   ref="newPassword"
                   autocomplete="off"
                   :placeholder="'Neues Passwort' | translate"
            >
            <label :data-error="errors.first('newPassword')"
                   class="auth-password">
            </label>

            <input class="auth-password auth-layout-login-form-text auth-layout-secondary"
                   v-model="confirmPassword" id="confirmPassword"
                   type="password" name="confirmPassword"
                   :data-vv-as="'Neues Passwort' | translate"
                   v-validate="confirmValidation"
                   @focusout="validateField('confirmPassword')"
                   :class="generateValidationClassMapping('confirmPassword')"
                   autocomplete="off"
                   :placeholder="'Neues Passwort bestätigen' | translate"
            >

            <label :data-error="errors.first('confirmPassword')"
                   class="error-handler">
            </label>
            <button
                class="auth-login wave auth-layout-tertiary auth-layout-button-text auth-layout-tertiary-border-color"
                :class="{'disabled-button' : isButtonDisabled }"

                :disabled="isButtonDisabled"
                type="submit" name="action"
            >
                {{ 'Weiter' | translate }}
            </button>

        </template>
        <template v-else-if="!tokenIsValid">
            <div class="row">
                <h5 class="center-align">
                    <i class="red-text material-icons valign">warning</i>
                    <span
                        class="auth-layout-text-and-icon">{{
                            'Dieses Passwort-Reset-Token ist ungültig.' | translate
                        }}
                    </span>
                </h5>
            </div>
            <div class="row">
                <div class="input-field col s12">
                    <a class="btn blue col s12" href="/login">
                        {{ 'Zum Login' | translate }}
                    </a>
                </div>
            </div>
        </template>
    </form>
</template>

<style>

</style>

<script>
import {translate} from 'pf/filter';
import Noty from "noty";

export default {
    props: {
        hashFromUrl: {
            required: false,
            type: String
        }
    },
    filters: {
        translate
    },
    data() {
        return {
            withOldPasswordConfirmation: null,
            passwordMinLength: 6,
            tokenIsValid: true
        }
    },
    created() {
        if (!this.hashFromUrl) return;

        this.hash = this.hashFromUrl;
        this.$store.dispatch('isTokenValid')
            .then(({data}) => {
                this.tokenIsValid = data.isValid;
                this.withOldPasswordConfirmation = data.oldPasswordIsRequired;
            })
            .catch(() => {
                this.tokenIsValid = false;
            });
    },
    methods: {
        validateField(field) {
            if (!this[field]) {
                this.$validator.errors.clear(field);
            }
            this.$validator.validate(field);
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (!result) return;{
                    this.$store.dispatch('changePassword')
                        .then(({data: {url}}) => {
                            window.location.href = url;
                        })
                        .catch(({response}) => {
                            new Noty ({
                                type: "error",
                                theme: "mint",
                                layout:"topRight",
                                text: translate('Änderungen konnten nicht gespeichert werden!'),
                                timeout: 6000,
                            }).show();
                            if ([404, 400].includes(response.status)) {
                                new Noty ({
                                    type: "error",
                                    theme: "mint",
                                    layout:"topRight",
                                    text: translate('Dieser Passwort-Reset-Token ist ungültig.'),
                                    timeout: 6000,
                                }).show();
                            }
                        });
                }
            });
        },
        isValid(key) {
            return !this.errors.has(key) && this.fields[key] && this.fields[key].touched;
        },
        generateValidationClassMapping(key) {
            return {
                invalid: this.errors.has(key),
                valid: this.isValid(key)
            }
        },
    },
    computed: {
        isButtonDisabled() {
            const isOldPasswordValid = !this.errors.has('confirmPassword');
            const isNewPasswordValid = !this.errors.has('newPassword');
            const isPasswordConfirmed = !this.errors.has('oldPassword')
            const isHashFilled = !this.errors.has('hash')
            return !(isOldPasswordValid && isNewPasswordValid && isHashFilled && isPasswordConfirmed);
        },
        hash: {
            get() {
                return this.$store.state.hash;
            },
            set(hash) {
                this.$store.commit('setHash', hash);
            }
        },
        oldPassword: {
            get() {
                return this.$store.state.oldPassword;
            },
            set(oldPassword) {
                this.$store.commit('setOldPassword', oldPassword);
            }
        },
        newPassword: {
            get() {
                return this.$store.state.newPassword;
            },
            set(newPassword) {
                this.$store.commit('setNewPassword', newPassword);
            }
        },
        confirmPassword: {
            get() {
                return this.$store.state.confirmPassword;
            },
            set(confirmPassword) {
                this.$store.commit('setConfirmPassword', confirmPassword);
            }
        },
        validation() {
            return `required|min:${this.passwordMinLength}`;
        },
        newPasswordValidation() {
            if (!this.withOldPasswordConfirmation) return this.validation;
            return `${this.validation}|is_not:${this.oldPassword}`;
        },
        confirmValidation() {
            return `${this.validation}|confirmed:newPassword`;
        }
    }
}
</script>
